import { LanguageAvailable } from '@shared/services/language';

export const FALLBACK_LANGUAGE: LanguageAvailable = 'fr';
